export const registerTypeList = [
  { key: "본사사용자", label: "본사 사용자", value: "본사사용자" },
  { key: "본사장비운전자", label: "본사 장비운전자", value: "본사장비운전자" },
  { key: "협력업체사용자", label: "협력업체 사용자", value: "협력업체사용자" },
  { key: "협력업체장비운전자", label: "협력업체 장비운전자", value: "협력업체장비운전자" },
  { key: "기타", label: "기타", value: "기타" },
];

export function getRegisterTypeInfo(key) {
  const type = registerTypeList.find((item) => item.key === key);
  return type ? { value: type.value, label: type.label } : null;
}
